var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeneralIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.616,
    height: 55.783,
    viewBox: "0 0 54.616 55.783",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3218",
    "data-name": "Group 3218",
    transform: "translate(-116.689 -467.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1725",
    "data-name": "Group 1725",
    transform: "translate(-5856.575 -1258)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1723",
    "data-name": "Group 1723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1721",
    "data-name": "Group 1721"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_864",
    "data-name": "Rectangle 864",
    width: 21.02,
    height: 21.02,
    transform: "translate(5979.552 1747.135)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.898
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_865",
    "data-name": "Rectangle 865",
    width: 7.882,
    height: 7.882,
    transform: "translate(5986.121 1747.135)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.898
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1722",
    "data-name": "Group 1722"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_866",
    "data-name": "Rectangle 866",
    width: 21.02,
    height: 21.02,
    transform: "translate(6000.572 1747.135)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.898
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_867",
    "data-name": "Rectangle 867",
    width: 7.882,
    height: 7.882,
    transform: "translate(6007.14 1747.135)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.898
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1724",
    "data-name": "Group 1724"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_868",
    "data-name": "Rectangle 868",
    width: 21.02,
    height: 21.02,
    transform: "translate(5990.062 1726.115)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.898
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_869",
    "data-name": "Rectangle 869",
    width: 7.882,
    height: 7.882,
    transform: "translate(5996.63 1726.115)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.898
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M5973.713,1768.155V1781h8.466v-4.963h11.97V1781h11.97v-4.963h11.97V1781h9.342v-12.845Z",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.898
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralIcon);
export default __webpack_public_path__ + "static/media/general-icon.333530e4737fe84ff54e69f9ff58be64.svg";
export { ForwardRef as ReactComponent };